/**
 * Initialize GTM dataLayer tracking for elements with data-dl-* attributes.
 *
 * Elements with data-dl-event will trigger a dataLayer.push() on click,
 * collecting all data-dl-* attributes as the payload.
 *
 * @example
 * ```html
 * <button
 *   data-dl-event="button_click"
 *   data-dl-category="cta"
 *   data-dl-label="signup"
 * >
 *   Sign Up
 * </button>
 * ```
 *
 * This would push: { event: "button_click", category: "cta", label: "signup" }
 */
export function initGTMTracking(): void {
  if (window.dataLayer === undefined) {
    return;
  }

  const trackedElements = document.querySelectorAll('[data-dl-event]');

  trackedElements.forEach((element) => {
    element.addEventListener('click', () => {
      const eventName = element.getAttribute('data-dl-event');

      if (eventName === null || eventName === '' || window.dataLayer === undefined) {
        return;
      }

      const dataLayerPayload: Record<string, string> = {
        event: eventName,
      };

      // Collect all data-dl-* attributes
      Array.from(element.attributes).forEach((attr) => {
        if (attr.name.startsWith('data-dl-')) {
          const propName = attr.name.replace('data-dl-', '');
          if (propName !== 'event') {
            dataLayerPayload[propName] = attr.value;
          }
        }
      });

      window.dataLayer.push(dataLayerPayload);
    });
  });
}
